// v6 E5/E6 — shared input helpers for numeric fields.
// One tap → auto-select content. Comma (Belgian/Dutch) accepted as decimal.
// setTimeout(0) is required to work around iOS Safari focus race conditions.

export function selectOnFocus(ev) {
  const el = ev.target;
  setTimeout(() => { try { el.select(); } catch (_) {} }, 0);
}

/** Parse a numeric input that may use "," or "." as decimal separator.
 *  Accepts "1,5", "1.5", "1.234,56" (BE/NL style), "1,234.56" (US style),
 *  empty string → 0, NaN → 0, leading whitespace trimmed.
 *  Used by NumF + InlineNum + raw type="text" inputMode="decimal" inputs.
 */
export function parseNum(raw, fallback = 0) {
  if (raw === null || raw === undefined) return fallback;
  let s = String(raw).trim();
  if (!s) return fallback;
  // Normalize: if BOTH comma and dot present, the LAST one is the decimal
  // separator (covers "1.234,56" and "1,234.56"). Strip the other as group sep.
  const lastComma = s.lastIndexOf(",");
  const lastDot = s.lastIndexOf(".");
  if (lastComma >= 0 && lastDot >= 0) {
    if (lastComma > lastDot) {
      s = s.replace(/\./g, "").replace(",", ".");
    } else {
      s = s.replace(/,/g, "");
    }
  } else if (lastComma >= 0) {
    s = s.replace(/,/g, ".");
  }
  const n = parseFloat(s);
  return Number.isFinite(n) ? n : fallback;
}

/** Same as parseNum but for integer fields (quantity steppers etc). */
export function parseInt2(raw, fallback = 0) {
  const n = parseNum(raw, fallback);
  return Math.trunc(n);
}
